import React, { useState, useEffect } from "react";
import { OuterContainer } from "../../EventCreation/styles";
import ActionBar from "../../common/ActionBar";
import styled from "styled-components";
import theme from "../../../assets/theme";
import {
  Paper,
  Typography,
  Grid,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { Formik, FieldArray } from "formik";
import FormField, { ButtonContainer, FormControl } from "../FormInputs";
import { PrimaryCTAButton, SecondaryCTAButton } from "../../common/Buttons";
import { AddCircleOutline, RemoveCircleOutline } from "@material-ui/icons";
import useLoader from "../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../../helpers/functions";
import EventService from "../../../services/EventService";
import { navigate } from "@reach/router";
import COLORS from "../../../assets/Colors";
import _ from "lodash";

const Polling = (id) => {
  const [items, setItems] = useState();
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const [clickedButton, setClickedButton] = useState("");
  const [triggerCall, setTriggerCall] = useState(false);
  const themes = useTheme();
  const isBigScreen = useMediaQuery(themes.breakpoints.up(640));

  const live_polls_inputs = [
    {
      name: "pushQuestionNumber",
      label: "Push Question Number",
      type: "select",
    },
    {
      name: "acceptingResponse",
      label: "Accepting Response",
      type: "radio",
      menuItems: [
        {
          name: "notAccept",
          value: "notAccept",
          label: "Not Accepting",
          empty: "",
        },
        {
          name: "pollsAreLive",
          value: "pollsAreLive",
          label: "Polls are Live",
        },
      ],
    },
  ];

  const inputs = [
    {
      name: "question",
      label: "Question",
      type: "text",
      placeholder: "Enter question",
    },
  ];

  const push_poll_inputs = [
    {
      name: "pushRollResults",
      label: "Push Result",
      type: "select",
    },
  ];

  const input_answers = [
    {
      name: "options",
      label: "Options",
      type: "text",
      placeholder: "Enter option",
    },
  ];

  const custom_buttons = [
    {
      label: "SAVE",
      color: "default",
      primary: true,
      name: "save",
    },
    {
      label: "SAVE & NEXT",
      color: "primary",
      secondary: true,
      name: "save&next",
    },
    {
      label: "CLEAR FORM",
      color: "secondary",
      clearForm: true,
    },
  ];

  useEffect(() => {
    async function getEventInfo() {
      try {
        setLoader({ state: true, message: "Fetching event details..." });
        const response = await EventService.getEvent(id?.id, "polling");
        setItems(response);
      } catch (err) {
        console.log(err);
      } finally {
        setLoader({ state: false });
        setTriggerCall(false);
        window.scrollTo(0, 0);
      }
    }
    if (id?.id) {
      getEventInfo();
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerCall]);

  async function getEventInfo() {
    try {
      setLoader({ state: true, message: "Fetching event details..." });
      const response = await EventService.getEvent(id?.id, "polling");
      setItems(response);
    } catch (err) {
      const message = getErrorMessage(err);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  /**
   * @description submit Polling
   */

  async function onFormSubmit(values) {
    try {
      setLoader({ state: true, message: "please wait..." });
      const payload = {
        ...values,
        pollQuestions: values?.pollQuestions?.map((item) => ({
          ...item,
          accept:
            values?.livePolls?.pushQuestionNumber === item?.question
              ? values?.livePolls?.acceptingResponse
              : item.accept,
          pollResult:
            values?.livePolls?.pushRollResults === item?.question
              ? true
              : item?.disabled,
        })),
        livePolls: {
          pushQuestionNumber: "",
          pushRollResults: values?.livePolls?.pushRollResults,
          acceptingResponse: "",
        },
      };
      const response = await EventService.updateEvent(id?.id, payload);
      if (response) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
      if (clickedButton === "save") {
        getEventInfo();
      } else {
        navigate(`/dashboard/eventmanager/faqs/${id?.id}`);
      }
    } catch (err) {
      enqueueSnackbar(err?.message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  const onBreadcrumbClick = (selected) => {
    switch (_.snakeCase(selected)) {
      case "event_manager":
        navigate(`/dashboard/eventmanager/home`);
        break;
      case "communicate":
        id?.id
          ? navigate(`/dashboard/eventmanager/communicate/${id?.id}`)
          : navigate(`/dashboard/eventmanager/communicate`);
        break;
      case "feedback":
        id?.id
          ? navigate(`/dashboard/eventmanager/feedback/${id?.id}`)
          : navigate(`/dashboard/eventmanager/feedback`);
        break;
      default:
        break;
    }
  };

  /**
   * @description handle button click
   */

  const handleButtonClick = (button, resetForm, handleSubmit) => {
    if (button.clearForm) {
      resetForm();
    } else {
      setClickedButton(button.name); // Store clicked button
      handleSubmit();
    }
  };

  return (
    <OuterContainer disabled={false}>
      <ActionBar
        breadcrumbs={
          id?.id
            ? [
                "Event Manager",
                localStorage.getItem("communicate-tab") === "true"
                  ? "Communicate"
                  : "Feedback",
                "Polling",
                items?.eventName
                  ? `${items?.eventName} (${items?.eventDate})`
                  : "",
              ]
            : [
                "Event Manager",
                localStorage.getItem("communicate-tab") === "true"
                  ? "Communicate"
                  : "Feedback",
                "Polling",
              ]
        }
        {...{ onBreadcrumbClick }}
      />
      <Container>
        <Formik
          initialValues={{
            pollQuestions: items?.pollQuestions?.length
              ? items?.pollQuestions?.map((item) => ({
                  question: item?.question,
                  options: item?.options,
                  disabled: item?.accept === "notAccept" ? true : false,
                  accept: item?.accept,
                  pollResult: item?.pollResult,
                }))
              : [{ question: "None", options: ["none"] }],
            livePolls: {
              pushQuestionNumber: items?.livePolls?.pushQuestionNumber || "",
              pushRollResults: items?.livePolls?.pushRollResults || "",
              acceptingResponse: items?.livePolls?.acceptingResponse || "",
            },
          }}
          enableReinitialize
          onSubmit={onFormSubmit}
          validateOnBlur
          validateOnChange
          validationSchema={""}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            setFieldValue,
            handleSubmit,
            resetForm,
          }) => (
            <FormContainer>
              <Container>
                <Paper elevation={3} style={{ padding: "16px" }}>
                  <Heading>Polling</Heading>
                  <FieldArray name="pollQuestions">
                    {({ push, remove }) => (
                      <div>
                        {values?.pollQuestions?.map((arr, qIndex) => (
                          <div
                            key={qIndex}
                            style={{
                              padding: "10px",
                              marginBottom: "10px",
                            }}
                          >
                            <Grid container item xs={12} spacing={3}>
                              {inputs.map((item, index) => (
                                <Grid item xs={12} key={item.name}>
                                  <FormField
                                    {...{
                                      item,
                                      handleChange,
                                      values,
                                      setFieldValue,
                                      errors,
                                      touched,
                                    }}
                                    direction={"row"}
                                    name={`pollQuestions[${qIndex}].question`}
                                    value={arr[item.name]}
                                    error={
                                      errors[item.name] && touched[item.name]
                                    }
                                    helperText={
                                      touched[item.name] && errors[item.name]
                                    }
                                  />
                                </Grid>
                              ))}
                            </Grid>
                            <FieldArray
                              name={`pollQuestions[${qIndex}].options`}
                            >
                              {({ push, remove }) => (
                                <div>
                                  <PollingContainer>
                                    {values.pollQuestions[qIndex].options.map(
                                      (arr, oIndex) => (
                                        <div
                                          key={oIndex}
                                          style={{ display: "flex" }}
                                        >
                                          {input_answers.map((item, index) => (
                                            <div
                                              item
                                              xs={12}
                                              key={item.name}
                                              style={{ marginTop: 10 }}
                                            >
                                              <FormField
                                                {...{
                                                  item,
                                                  handleChange,
                                                  values,
                                                  setFieldValue,
                                                  errors,
                                                  touched,
                                                }}
                                                direction={"row"}
                                                name={`pollQuestions[${qIndex}].options[${oIndex}]`}
                                                value={arr}
                                                error={
                                                  errors[item.name] &&
                                                  touched[item.name]
                                                }
                                                helperText={
                                                  touched[item.name] &&
                                                  errors[item.name]
                                                }
                                              />
                                            </div>
                                          ))}
                                          <div
                                            style={{
                                              cursor: "pointer",
                                              width: "auto",
                                              marginLeft: "8px",
                                              marginTop: "45px",
                                            }}
                                            onClick={() => remove(oIndex)}
                                          >
                                            <RemoveCircleOutline
                                              style={{
                                                color: COLORS.LOGOUT_RED,
                                              }}
                                            />{" "}
                                          </div>
                                        </div>
                                      ),
                                    )}
                                  </PollingContainer>
                                  <ButtonWrapper>
                                    <SecondaryCTAButton
                                      onClick={() => push("")}
                                      style={{
                                        paddingLeft: 0,
                                        color: COLORS.TRANSCRIPT_GRAY,
                                      }}
                                    >
                                      <AddCircleOutline
                                        style={{
                                          marginRight: "10px",
                                          marginLeft: "5px",
                                          color: COLORS.TRANSCRIPT_GRAY,
                                        }}
                                      />{" "}
                                      Add Option
                                    </SecondaryCTAButton>
                                  </ButtonWrapper>
                                </div>
                              )}
                            </FieldArray>
                            <Grid
                              item
                              xs={12}
                              style={{
                                textAlign: "left",
                                marginTop: "20px",
                              }}
                            >
                              <PrimaryCTAButton
                                style={{
                                  width: "auto",
                                  marginLeft: 8,
                                }}
                                onClick={() => remove(qIndex)}
                              >
                                Delete
                              </PrimaryCTAButton>
                            </Grid>
                          </div>
                        ))}
                        <ButtonWrapper>
                          <SecondaryCTAButton
                            onClick={() =>
                              push({ question: "", options: [""] })
                            }
                            style={{ paddingLeft: 0 }}
                          >
                            <AddCircleOutline
                              style={{
                                marginRight: "10px",
                                marginLeft: "5px",
                              }}
                            />{" "}
                            Add Question
                          </SecondaryCTAButton>
                        </ButtonWrapper>
                      </div>
                    )}
                  </FieldArray>
                  <FormControl>
                    <ButtonContainer>
                      {custom_buttons.map((button) => (
                        <PrimaryCTAButton
                          style={{ width: "auto", marginLeft: 8 }}
                          onClick={() =>
                            handleButtonClick(button, resetForm, handleSubmit)
                          }
                        >
                          {button.label}
                        </PrimaryCTAButton>
                      ))}
                    </ButtonContainer>
                  </FormControl>
                  <Paper
                    elevation={3}
                    style={{
                      padding: 16,
                      border: "1px solid #e1e3ee",
                      marginTop: "15px",
                      marginBottom: "15px",
                    }}
                  >
                    <GridLabel>Live Polls</GridLabel>
                    <Grid
                      container
                      item
                      xs={12}
                      spacing={3}
                      style={{ padding: 16 }}
                    >
                      {live_polls_inputs.map((item, idx) => (
                        <Grid
                          item
                          xs={isBigScreen ? 6 : 12}
                          key={item.name}
                          style={styles.gridItem}
                        >
                          <FormField
                            {...{ item, values, errors, touched }}
                            handleChange={(e) => {
                              if (item.name === "pushQuestionNumber") {
                                setFieldValue(
                                  `livePolls.${item.name}`,
                                  e.target.value,
                                );
                                setFieldValue(
                                  `livePolls.acceptingResponse`,
                                  "",
                                );
                              } else {
                                setFieldValue(
                                  `livePolls.${item.name}`,
                                  e.target.value,
                                );
                              }
                            }}
                            name={`livePolls.${item.name}`}
                            menuItems={
                              item.name === "pushQuestionNumber"
                                ? values?.pollQuestions.map((item) => ({
                                    label: item.question,
                                    value: item.question,
                                    disabled: item.disabled,
                                    accept: item.accept,
                                  }))
                                : item.name === "acceptingResponse"
                                ? item?.menuItems?.map((find) => ({
                                    label: find.label,
                                    name: find.name,
                                    value: find.value,
                                    disabled:
                                      values?.pollQuestions.find(
                                        (item) =>
                                          item.question ===
                                          values?.livePolls?.pushQuestionNumber,
                                      )?.accept === "notAccept"
                                        ? true // Disable both
                                        : values?.pollQuestions.find(
                                            (item) =>
                                              item.question ===
                                              values?.livePolls
                                                ?.pushQuestionNumber,
                                          )?.accept === "pollsAreLive"
                                        ? find.name === "pollsAreLive" // Disable only pollsAreLive
                                        : values?.pollQuestions.find(
                                            (item) =>
                                              item.question ===
                                              values?.livePolls
                                                ?.pushQuestionNumber,
                                          )?.accept === ""
                                        ? find.name === "notAccept" // Disable only notAccept
                                        : false, // Default to false
                                  }))
                                : item.menuItems
                            }
                            value={values.livePolls[item.name]}
                            direction={"row"}
                          />
                        </Grid>
                      ))}
                    </Grid>
                    <PrimaryCTAButton
                      style={{ width: "auto", marginLeft: "24px" }}
                      onClick={() => {
                        setClickedButton("save");
                        handleSubmit();
                      }}
                    >
                      Push poll
                    </PrimaryCTAButton>
                  </Paper>
                  <Paper
                    elevation={3}
                    style={{
                      padding: 16,
                      border: "1px solid #e1e3ee",
                      marginTop: "15px",
                      marginBottom: "15px",
                      borderRadius: "8px",
                    }}
                  >
                    <GridLabel>Push Poll Results</GridLabel>
                    <Grid
                      container
                      item
                      xs={12}
                      spacing={3}
                      style={{ padding: 16 }}
                    >
                      {push_poll_inputs.map((item, idx) => (
                        <Grid
                          item
                          xs={12}
                          key={item.name}
                          style={styles.gridItem}
                        >
                          <FormField
                            {...{
                              item,
                              values,
                              handleChange,
                              errors,
                            }}
                            name={`livePolls.${item.name}`}
                            touched={`livePolls.${item.name}`}
                            menuItems={values?.pollQuestions.map((item) => ({
                              label: item.question,
                              value: item.question,
                              disabled: item.pollResult,
                            }))}
                            value={values.livePolls[item.name]}
                            direction={"row"}
                          />
                        </Grid>
                      ))}
                    </Grid>
                    <PrimaryCTAButton
                      style={{ width: "auto", marginLeft: "24px" }}
                      onClick={() => {
                        setClickedButton("save");
                        handleSubmit();
                      }}
                    >
                      Push Results
                    </PrimaryCTAButton>
                  </Paper>
                </Paper>
              </Container>
            </FormContainer>
          )}
        </Formik>
      </Container>
    </OuterContainer>
  );
};

const styles = {
  container: {
    backgroundColor: "#A9A9A9", // gray background
    padding: "20px",
    borderRadius: "8px",
  },
  gridItem: {
    display: "flex",
    justifyContent: "space-between",
  },
  label: {
    fontWeight: "bold",
  },
};

export default Polling;

const Container = styled.div`
  padding: 20px 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  & .delete {
    display: flex;
    cursor: pointer;
  }
`;

const Heading = styled(Typography)(() => ({
  backgroundColor: "#00aeef",
  color: "#fff",
  padding: "8px",
  fontFamily: theme.fonts.primaryFontBold,
  borderRadius: "5px",
}));

const FormContainer = styled.form`
  /* width: 907px; */

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  @media ${theme?.breakpoints?.md_up} {
    width: 100%;
  }
`;

export const ButtonWrapper = styled.div`
  width: fit-content;
  @media ${theme?.breakpoints?.md_up} {
    justify-content: flex-start;
    display: flex;
    padding-bottom: 20px;
    padding-top: 7px;
  }
`;
const GridLabel = styled(Typography)(() => ({
  width: "250px",
  color: " #00838c",
  fontSize: "15px",
  marginTop: "10px",
  marginBottom: "10px",
  marginLeft: "15px",
  fontFamily: theme.fonts.primaryFontSemiBold,
}));

const PollingContainer = styled.div`
  @media ${theme.breakpoints.sm_up} {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 10px;
  }
`;
